export default (number) => `${number || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
